// apiClient.ts
import axios, { AxiosError, AxiosInstance, AxiosRequestConfig } from 'axios';
import { CMS_API_BASE } from './constants';

export const API_CONFIG = { 
   BASE_URL: CMS_API_BASE, //UAT Client URL 
  TIMEOUT: 30000, // 25 seconds
}; 

const apiClient = axios.create({
  baseURL: API_CONFIG.BASE_URL ,
  // timeout : API_CONFIG.TIMEOUT,
/*  auth: {
    username: "your_username",
    password: "your_password"
  },*/
  headers: {
    "Content-Type": "application/json",
    "Accept": "application/vnd.api+json",
    'Cache-Control': 'max-age=6000' , 
    // "Accept-Encoding": "gzip, deflate"

   // 'Access-Control-Allow-Origin': '*',
   // 'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS' 
  },
});
export default apiClient;